import React, { useState } from "react";
import {
  Row,
  Col,
  Input,
  Form,
  message,
  Spin,
  Select,
  Button,
  Divider,
} from "antd";
import API from "../../api";
import urls from "../../api/urls";
import Heading from "../../components/Heading";
import PinCodeValidator from "../../components/PincodeValidator";
import RatesTable from "./RatesTable";
import { getCurretRole, preventTextPaste } from "../../utils";

const userId = JSON.parse(localStorage.getItem("userId"));
const { POST_RATE_CALCULATE } = urls;

const productTypeOptions = [
  { label: "Dox", value: "dox" },
  { label: "Non-Dox", value: "nonDox" },
];

const RateCalculator = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [productType, setProductType] = useState("dox");
  const [rateData, setRateData] = useState({});
  //const [clearData, setClearData] = useState(false);
  const [defaultPincode, setDefaultPincode] = useState(
    userId?.premises?.pincode || ""
  );

  const weightValidation = () => ({
    validator(_, value) {
      // if (!value) return Promise.reject("Enter weight");

      const numericValue = parseFloat(value);
      const isDox = productType === "dox";

      if (
        (isDox && (numericValue < 50 || numericValue > 3500)) ||
        (!isDox && (numericValue < 0.1 || numericValue > 499.99))
      ) {
        return Promise.reject(
          `Weight must be between ${
            isDox ? "50g and 3500g" : "0.1kg and 499.99kg"
          }`
        );
      }

      if (value.includes("..")) return Promise.reject("Invalid decimal format");

      return Promise.resolve();
    },
  });

  const isClientAdmin = getCurretRole();

  const submitRateCalculate = async (val) => {
    setLoading(true);

    const companyId =
      JSON.parse(localStorage.getItem("selectedCompany"))?.key || "";

    const userId = JSON.parse(localStorage.getItem("userId"))?.userInfo || "";

    const payload = {
      ...val,
      userId: companyId?.toString() || String(userId?.userId),
      type: isClientAdmin ? "ACCOUNT" : "CASH",
      weight: productType === "dox" ? +val.weight : +val.weight * 1000,
      fromPincode: +val.fromPincode,
      toPincode: +val.toPincode,
    };

    try {
      const res = await API.Api(POST_RATE_CALCULATE).post(payload);
      if (res?.status) {
        setRateData(res?.response?.data);
      } else {
        message.error(res?.response?.data?.message || "Internal server error.");
      }
    } catch (error) {
      message.error("Error calculating rates. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  // const clearRates = () => {
  //   form.resetFields();
  //   setRateData({});
  //   setClearData((prev) => !prev);
  // };

  return (
    <div className="master-main-container p-1">
      <Heading title="Rate Calculator" />
      <Spin spinning={loading}>
        <Form
          className="global-form"
          layout="vertical"
          form={form}
          initialValues={{
            productType: "dox",
            fromPincode: defaultPincode,
          }}
          onFinish={submitRateCalculate}
        >
          <Row gutter={24} className="global-form-row p-1">
            <Col span={5}>
              <Form.Item
                name="productType"
                label="Shipment Type"
                rules={[{ required: true, message: "Select shipment type" }]}
              >
                <Select
                  options={productTypeOptions}
                  onChange={setProductType}
                  placeholder="Select shipment type"
                />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item
                name="weight"
                label={`Weight (${productType === "dox" ? "Gms" : "Kgs"})`}
                rules={[
                  { required: true, message: "Enter weight" },
                  weightValidation(),
                ]}
              >
                <Input
                  type="number"
                  maxLength={7}
                  placeholder={`Enter weight in ${
                    productType === "dox" ? "grams" : "kilograms"
                  }`}
                  onInput={(e) => preventTextPaste(e, 7)}
                />
              </Form.Item>
            </Col>

            <Col span={5}>
              <PinCodeValidator
                formName="fromPincode"
                label="From Pincode"
                value={defaultPincode}
                changeHit={() => setDefaultPincode(null)}
                type={"checkService"}
              />
            </Col>

            <Col span={5}>
              <PinCodeValidator
                formName="toPincode"
                label="To Pincode"
                type={"checkService"}
              />
            </Col>
            <Col span={5}>
              <Form.Item name="length" label="Length (cm)">
                <Input
                  type="number"
                  placeholder="Enter length"
                  onInput={(e) => preventTextPaste(e, 5)}
                />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item name="width" label="Width (cm)">
                <Input
                  type="number"
                  placeholder="Enter width"
                  onInput={(e) => preventTextPaste(e, 5)}
                />
              </Form.Item>
            </Col>

            <Col span={5}>
              <Form.Item name="height" label="Height (cm)">
                <Input
                  type="number"
                  placeholder="Enter height"
                  onInput={(e) => preventTextPaste(e, 5)}
                />
              </Form.Item>
            </Col>

            <Col span={4} className="d-flex">
              {/* <Button onClick={clearRates} className="cancel-btn mt-2 mr-1">
                CLEAR
              </Button> */}
              <Button htmlType="submit" className="save-btn mt-2">
                SUBMIT
              </Button>
            </Col>
          </Row>
        </Form>
        <Divider />
        <RatesTable rateData={rateData} />
      </Spin>
    </div>
  );
};

export default RateCalculator;
